import { getFormattedCargoNumber, getShortFormattedCargoNumber, isManualCargo } from 'src/utils/stowage/cargoOperationUtils';
import { getCargoColor } from 'src/utils/stowage/cargoColorsUtils';
import { CargoNumberStyle } from '../Stowage.styles';
import { RotationCargo } from 'src/types/ViewModel/Stowage/Rotation/RotationCargo';

interface Props {
    includeColoredBackground?: boolean;
    includeHash?: boolean;
    includeUscgNumber?: boolean;
    cargo: RotationCargo;
    bold?: boolean;
    includeVoyage?: boolean;
    withPadding?: boolean;
}

const CargoNumber: React.FC<Props> = ({
    includeColoredBackground,
    includeHash,
    includeUscgNumber,
    cargo,
    bold,
    includeVoyage,
    withPadding,
}: Props) => {
    const isManual = isManualCargo(cargo);
    return (
        <CargoNumberStyle color={includeColoredBackground ? getCargoColor(cargo) : null} withPadding={withPadding} bold={bold}>
            {includeHash && <>#</>}
            {includeVoyage !== false && getFormattedCargoNumber(cargo.voyageNumber, cargo.cargoNumber, isManual)}

            {includeVoyage === false && getShortFormattedCargoNumber(cargo.cargoNumber, isManual)}

            {includeUscgNumber && cargo.product.uscgGroup.number > 0 && <span> ({cargo.product.uscgGroup.number})</span>}
        </CargoNumberStyle>
    );
};

export default CargoNumber;
